/**
 * Formata percentual com 2 casas decimais e vírgula (ex: 52.34 -> "52,34%").
 */
export function formatarPercentual(valor: number | null | undefined): string {
  if (valor == null || Number.isNaN(valor)) return '';
  return valor.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }) + '%';
}

/**
 * Formata quantidade de votos com separador de milhar (ex: 12345678 -> "12.345.678").
 */
export function formatarVotos(votos: number | null | undefined): string {
  if (votos == null || Number.isNaN(votos)) return '0';
  return votos.toLocaleString('pt-BR');
}

/**
 * Formata timestamp ISO para HH:mm no fuso horário oficial de Brasília (America/Sao_Paulo).
 */
export function formatarHorario(iso: string | null | undefined): string {
  if (!iso) return '';
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return '';

  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(data);
}
